'use client';

import React from 'react';

import ProtectionPlanTypesContext from './ProtectionPlanTypesContext';

// Provides server-fetched getProtectionPlanTypes data to the PDP subtree so
// useAllProtectionPlanTypes() resolves without an Apollo client round-trip.
// `value` is the full fetchFromAlexandria() result object — same shape as the
// Apollo `data` returned by useSuspenseQuery(GET_PROTECTION_PLAN_TYPES).
const ProtectionPlanTypesProvider = ({ value = null, children }) => (
  <ProtectionPlanTypesContext.Provider value={value}>
    {children}
  </ProtectionPlanTypesContext.Provider>
);

export default ProtectionPlanTypesProvider;
